import { isFunction } from 'lodash/fp';
import React, { PropsWithChildren, ReactElement, ReactNode, cloneElement } from 'react';

type Props = {
	/**
	 * Either React component or function which will receive children as argument
	 *
	 * Example:
	 *
	 *   <Wrapped into={<span />}>FOO</Wrapped>
	 *
	 *   is the same as
	 *
	 *   <Wrapped into={(children) => <span>{children}</span>}>FOO</Wrapped>
	 */
	into?:
		| React.ReactElement
		| ((children: React.ReactNode) => React.ReactElement<ReactElement, string>);
};

const Wrapped = (props: PropsWithChildren<Props>): ReactNode => {
	return !props.into
		? props.children
		: isFunction(props.into)
		? props.into(props.children)
		: cloneElement(props.into, {}, props.children);
};

export default Wrapped;
